﻿
export enum TimeScale {
    Week,
    Month,
    Quarter,
    Year,
    FiveYear
}
